<!-- Single Item -->
<div *ngIf="mediaItems && mediaItems.length === 1">
    <div class="image-container-one">
        <div class="media-item">
            <!--<div *ngIf="mediaItems[0].mimeType.startsWith('video/')" class="video-container">-->
            <div *ngIf="mediaItems[0].mediaSource === 'local'; else imageTemplate" class="video-container">
                <div *ngIf="mediaItems[0].mimeType.startsWith('video/')" class="video-container">
                    <video controls class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" [src]="getMediaUrl(mediaItems[0])">
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div *ngIf="mediaItems[0].mimeType.startsWith('image/')" >
                    <img [src]="getMediaUrl(mediaItems[0])" class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" alt="Media">
                </div>
            </div>

            <ng-template #imageTemplate>
                <img [src]="mediaItems[0].isPlaying ? mediaItems[0].mediaAnimatedUrl : mediaItems[0].mediaUrl"
                     class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" (click)="togglePlay(0, $event)">
            </ng-template>
            <div class="overlay-controls" (click)="togglePlay(0, $event)">
                <!-- Toggle Play/Pause if the URL is from Tenor -->
                <button *ngIf="mediaItems[0].isTenor && !mediaItems[0].isPlaying" class="btn play-btn position-absolute center">
                    <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                        <g>
                            <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                            <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                        </g>
                    </svg>
                </button>
                <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                <button *ngIf="mediaItems[0].isTenor && mediaItems[0].isPlaying" class="btn play-btn position-absolute center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                        <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                            <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                        </g>
                    </svg>
                </button>
            </div>
        </div>
        </div>

</div>

<!-- Carousel for Multiple Items -->
<div *ngIf="mediaItems && mediaItems.length > 1; else noItems" class="carousel-container position-relative">
    <p-carousel [value]="mediaItems" numVisible="2" numScroll="1" [circular]="true" [responsiveOptions]="responsiveOptions"
                [ngClass]="{'left': isAtStart, 'right': isAtEnd}" (onPage)="updateActiveIndex($event)"
                (click)="onCarouselClick($event)">
        <ng-template let-item pTemplate="item">
            <!--<div>{{ item | json }}</div>-->  <!--Add this line to debug--> 
            <div class="carousel-item-wrapper">
                <div class="image-container">
                    <div *ngIf="item.mediaSource === 'local'; else imageTemplate" class="video-container">
                        <!-- Video -->
                        <div *ngIf="item.mimeType.startsWith('video/')" class="video-container">
                            <video controls class="img-fluid" [src]="getMediaUrl(item)">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <!-- Image -->
                        <div *ngIf="item.mimeType.startsWith('image/')" class="image-container">
                            <img [src]="getMediaUrl(item)" class="img-fluid" alt="Media">
                        </div>
                    </div>

                    <ng-template #imageTemplate>
                        <img [src]="item.isPlaying ? item.mediaAnimatedUrl : item.mediaUrl"
                             class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" (click)="togglePlay(item.index, $event)">
                    </ng-template>
                    <div class="overlay-controls" (click)="togglePlay(item.index, $event)">
                        <!-- Toggle Play/Pause if the URL is from Tenor -->
                        <button *ngIf="item.isTenor && !item.isPlaying" class="btn play-btn position-absolute center">
                            <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                                <g>
                                    <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                    <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                                </g>
                            </svg>
                        </button>
                        <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                        <button *ngIf="item.isTenor && item.isPlaying" class="btn play-btn position-absolute center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                                <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                    <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>

            </div>
        </ng-template>
    </p-carousel>
</div>


<ng-template #noItems>
    <ng-container *ngIf="!mediaItems">
        <div>No media items available.</div>
    </ng-container>
</ng-template>
